import { Component, OnInit,Inject} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-upgrade',
  templateUrl: './Apoinment.component.html',
  styleUrls: ['./Apoinment.component.css']
})
export class ApoinmentComponent implements OnInit {

  constructor(public dialog: MatDialog) {
 
  }
  pageEvent: PageEvent;
  ngOnInit() {
  }

}
